﻿package com.milta.core.localization.translations.sq

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Profili im",
    sectionPersonal = "Informacione personale",
    labelFirstName = "Emri",
    labelLastName = "Mbiemri",
    labelRole = "Roli",
    sectionLanguage = "Gjuha",
    labelLanguage = "Gjuha e aplikacionit",
    changeLanguageButton = "Ndrysho gjuhën",
    languageDialogTitle = "Zgjidhni gjuhën tuaj",
    languageDialogConfirm = "Konfirmo",
    languageDialogCancel = "Anulo",
    sectionPassword = "Siguria",
    labelCurrentPassword = "Fjalëkalimi aktual",
    labelNewPassword = "Fjalëkalim i ri",
    changePasswordButton = "Ndrysho fjalëkalimin",
    successLanguageUpdated = "Gjuha u përditësua me sukses",
    successPasswordChanged = "Fjalëkalimi u ndryshua me sukses",
    errorProfileNotFound = "Profili nuk u gjet",
    errorCurrentPasswordRequired = "Ju lutem shkruani fjalëkalimin tuaj aktual",
    errorCurrentPasswordTooLong = "Fjalëkalimi aktual nuk mund të kalojë 128 karaktere",
    errorNewPasswordRequired = "Ju lutem shkruani një fjalëkalim të ri",
    errorNewPasswordTooShort = "Fjalëkalimi i ri duhet të ketë të paktën 8 karaktere",
    errorNewPasswordTooLong = "Fjalëkalimi i ri nuk mund të kalojë 128 karaktere",
    errorLanguageRequired = "Ju lutem zgjidhni një gjuhë",
    errorForbidden = "Nuk jeni i autorizuar të kryeni këtë veprim",
    errorValidation = "Të dhënat e dhëna janë të pavlefshme",
    errorGeneric = "Ndodhi një gabim. Ju lutem provoni përsëri.",
    signOut = "Dilni",
    deleteAccount = "Fshi llogarinë",
    menuLanguage = "Gjuha e ndërfaqes",
    menuPassword = "Ndrysho fjalëkalimin",
    menuSubscription = "Abonimi im",
    menuPrivacy = "Privatësia & GDPR",
    linkedCodeLabel = "Kodi unik i lidhjes",
    copyCode = "Kopjo",
    codeCopied = "Kopjuar!",
    modeOrganisation = "Ndërmarrje",
    modeDriver = "Shofer",
    roleDriver = "Shofer",
    roleOrganisation = "Ndërmarrje",
    modeSwitchTitle = "Ndrysho mënyrën",
    modeSwitchHint = "Kaloni midis Mënyrës Ndërmarrje dhe Mënyrës Shofer në çdo kohë",
    switchToEnterprise = "Mënyra Ndërmarrje",
    switchToDriver = "Mënyra Shofer",
    menuPhone = "Numri i telefonit",
    phoneOtpStepTitle = "Kodi i verifikimit dërguar me SMS",
    successPhoneUpdated = "Numri i telefonit u përditësua",
    deleteAccountDialogTitle = "Të fshini llogarinë tuaj?",
    deleteAccountDialogMessage = "Ky veprim është i pakthyeshëm. Informacioni juaj personal do të fshihet. Një kod verifikimi do të dërgohet me SMS për konfirmim.",
    deleteAccountDialogConfirm = "Vazhdo",
    deleteAccountOtpStepTitle = "Kodi i verifikimit dërguar me SMS",
    deleteAccountConfirmButton = "Fshi përfundimisht",
    errorLastEnterpriseOwner = "Ju jeni i vetmi menaxher i ndërmarrjes suaj. Shtoni një llogari tjetër Ndërmarrje përpara se të fshini tuajën.",
    logoutPendingWarningTitle = "Dërgesa të padërguara",
    logoutPendingWarningMessageSuffix = "dërgesë/a në pritje do të humbasin nëse dilni tani.",
    logoutPendingWarningConfirm = "Dil gjithsesi",
    logoutPendingWarningCancel = "Anulo",
    modeSwitchActiveRouteWarningTitle = "Turi në vazhdim",
    modeSwitchActiveRouteWarningMessage = "Aktualisht një tur është në vazhdim. Ndryshimi i modalitetit do t'ju largojë nga ndjekja e tij. Vazhdoni?",
    modeSwitchActiveRouteWarningConfirm = "Ndrysho gjithsesi",
    modeSwitchActiveRouteWarningCancel = "Anulo",
)

